"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var RatingIcon_1 = __importDefault(require("./Util/RatingIcon"));
var genIcon_1 = __importDefault(require("../../utils/genIcon"));
var Rating = /** @class */ (function (_super) {
    __extends(Rating, _super);
    function Rating(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value >= 0 ? _this.props.value : 0,
            savedValue: _this.props.value >= 0 ? _this.props.value : 0,
            prevValue: 0,
            click: false
        };
        return _this;
    }
    Rating.prototype.componentDidUpdate = function (nextProps) {
        var value = this.props.value;
        if (nextProps.value !== value) {
            this.setState({ value: value, savedValue: value });
        }
    };
    Rating.prototype.render = function () {
        var className = this.props.className;
        var classes = 'star-rating';
        classes += className ? " " + className : '';
        return (React.createElement("div", { className: classes },
            this.getRating(),
            React.createElement("div", { className: "stars-container" }, this.props.edit ? this.getStarsEdit() : this.getStarsStatic())));
    };
    Rating.prototype.setRating = function (value) {
        this.setState({
            value: value,
            prevValue: value,
            savedValue: value,
            click: true
        });
    };
    Rating.prototype.handleMouseEnter = function (value) {
        var _this = this;
        setTimeout(function () {
            if (value !== _this.state.value) {
                _this.setState({
                    prevValue: _this.state.value,
                    value: value
                });
            }
        }, 0);
    };
    Rating.prototype.handleMouseLeave = function () {
        var _this = this;
        setTimeout(function () {
            _this.setState({
                value: _this.state.savedValue,
                click: false
            });
        }, 0);
    };
    // Return array of star svgs that are editable and have animated hovers
    Rating.prototype.getStarsEdit = function () {
        var _this = this;
        var stars = [];
        var _loop_1 = function (i) {
            var id = Math.random();
            var classes = 'edit-mode';
            var value = Number(this_1.state.value.toFixed(this_1.props.precision));
            var percent = value - i + 1;
            // Determine the fill of this star - fill is the gradient if partial
            var fill = this_1.props.unfilledColor;
            if (value - i + 1 > 0) {
                if (value - i + 1 < 1) {
                    fill = "url(#id_" + id + ")";
                }
                else {
                    if (i >= this_1.state.prevValue || i === value) {
                        classes += ' filled';
                    }
                    fill = this_1.props.filledColor;
                }
                // When unhovering or reducing value add class for animation
            }
            else if (i <= this_1.state.prevValue) {
                classes += ' unfilled';
            }
            if (i <= value) {
                classes += ' hide-unfilled';
            }
            var rating = void 0;
            if (this_1.props.icon && this_1.props.icon.type !== "svg") {
                var iconPercent = percent;
                if (percent > 1)
                    iconPercent = 1;
                if (percent < 0)
                    iconPercent = 0;
                if (classes.includes('filled')) {
                    iconPercent = 1;
                }
                rating = (React.createElement("div", null,
                    React.createElement("div", { className: "unfilled-icon-wrapper", style: {
                            color: this_1.props.unfilledColor
                        } }, genIcon_1.default(this_1.props.icon, {
                        root: this_1.props.icon.props.root,
                        className: "icon " + classes,
                        size: ['small', 'medium', 'large', 'xlarge'].includes(this_1.props.size) ?
                            this_1.props.size : 'small'
                    })),
                    React.createElement("div", { className: "icon-wrapper", style: {
                            width: this_1.getSize() * iconPercent + "px",
                            color: this_1.props.filledColor
                        } }, genIcon_1.default(this_1.props.icon, {
                        root: this_1.props.icon.props.root,
                        className: "icon " + classes,
                        size: ['small', 'medium', 'large', 'xlarge'].includes(this_1.props.size) ?
                            this_1.props.size : 'small'
                    }))));
            }
            else {
                rating = (React.createElement(RatingIcon_1.default, { percent: percent, className: classes, id: "id_" + id, fill: fill, icon: this_1.props.icon, size: this_1.getSize() + "px", fillColor: this_1.props.filledColor, unfillColor: this_1.props.unfilledColor }));
            }
            stars.push(React.createElement("div", { className: 'spacing', key: id },
                React.createElement("div", { className: classes, onClick: function () {
                        _this.setRating(i);
                        if (_this.props.onChange) {
                            _this.props.onChange(i, _this.props.total);
                        }
                    }, onMouseEnter: function () { _this.handleMouseEnter(i); }, onMouseLeave: function () { _this.handleMouseLeave(); }, key: id + 'inner', style: {
                        marginLeft: this_1.getSize() / 6 + "px",
                        width: this_1.getSize() + "px",
                        height: this_1.getSize() + "px"
                    } }, rating)));
        };
        var this_1 = this;
        for (var i = 1; i <= this.props.total; i++) {
            _loop_1(i);
        }
        return stars;
    };
    // Return non-modifyable array of rating icons
    Rating.prototype.getStarsStatic = function () {
        var stars = [];
        for (var i = 1; i <= this.props.total; i++) {
            var id = Math.random();
            var value = Number(this.state.value.toFixed(this.props.precision));
            var percent = value - i + 1;
            var rating = void 0;
            if (this.props.icon && this.props.icon.type !== "svg") {
                var iconPercent = percent;
                if (percent > 1)
                    iconPercent = 1;
                if (percent < 0)
                    iconPercent = 0;
                var classes = 'icon';
                if (i <= value) {
                    classes += ' hide-unfilled';
                }
                rating = (React.createElement("div", null,
                    React.createElement("div", { className: "unfilled-icon-wrapper" }, genIcon_1.default(this.props.icon, {
                        root: this.props.icon.props.root,
                        className: classes,
                        size: this.props.size
                    })),
                    React.createElement("div", { className: "icon-wrapper", style: { width: iconPercent + " * 100%" } }, genIcon_1.default(this.props.icon, {
                        root: this.props.icon.props.root,
                        className: "icon",
                        size: this.props.size
                    }))));
            }
            else {
                rating = (React.createElement(RatingIcon_1.default, { percent: percent, id: "id_" + id, fill: "url(#id_" + id + ")", icon: this.props.icon, size: this.getSize() + "px", fillColor: this.props.filledColor, unfillColor: this.props.unfilledColor }));
            }
            stars.push(React.createElement("div", { className: 'spacing', key: id + 'inner' },
                React.createElement("div", { key: id + 'inner', style: {
                        marginLeft: this.getSize() / 6 + "px",
                        width: this.getSize() + "px",
                        height: this.getSize() + "px"
                    } }, rating)));
        }
        return stars;
    };
    Rating.prototype.getRating = function () {
        // rating is capped at total stars
        var value = this.state.savedValue <= this.props.total
            ? this.state.savedValue
            : this.props.total;
        var rating = value.toFixed(this.props.precision);
        // Add pop class for animation when new star is selected
        var classes = 'rating-value';
        if (this.props.edit) {
            if (this.state.savedValue === this.state.prevValue && this.state.click) {
                classes += ' pop';
            }
        }
        return React.createElement("span", { className: classes, style: { fontSize: this.getSize() + "px" } }, rating);
    };
    Rating.prototype.getSize = function () {
        var size = this.props.size;
        if (['small', 'medium', 'large', 'xlarge'].indexOf(size) !== -1) {
            var index = [, , 'small', 'medium', 'large', , , , 'xlarge'].indexOf(size);
            return 8 * index;
        }
        return 16;
    };
    Rating.defaultProps = {
        total: 5,
        value: 0,
        edit: false,
        size: 'small',
        filledColor: '#F5A623',
        unfilledColor: '#707070',
        precision: 1
    };
    return Rating;
}(React.Component));
exports.default = Rating;
